import Input from "../../../../../components/input/Input";
import { useWebsite } from "../Context/WebSiteContext";

const LocSite = ({ control, setValue, errors, templateId }) => {
  const { formData, updateFormData } = useWebsite();

  return (
    <div>
      <Input
        control={control}
        label="Insira o link do Google Maps"
        name="loc.localizacao"
        className="form-control mb-1 mt-0"
        defaultValue={formData.loc?.localizacao || ""}
        onChange={(e) => {
          updateFormData("loc", "localizacao", e.target.value);
          setValue("loc.localizacao", e.target.value);
        }}
        rules={{ required: "Informe a localização" }}
      />
      <small className="text-muted">
        Copie apenas o link de incorporação dentro de <code>src="..."</code> do
        Google Maps.
      </small>
    </div>
  );
};
export default LocSite;
